import React from "react";
import { Box, Typography, Link as MuiLink } from "@mui/material";
import { Link } from "react-router-dom";
import Logo from "../assets/image/Aysa-Wordmark.svg"; // update path

export const Footer = () => {
  return (
    <Box
      component="footer"
      justifyContent="center"
      sx={{
        backgroundColor: "#2D2D2D",
        color: "#F3F3F3",
        textAlign: "center",
        py: 4,
        px: "var(--layout-margin)",
      }}
    >
      {/* Row 1: Logo */}
      <Box display="flex" justifyContent="center" alignItems="center" mb={3}>
        <Link to="/">
          <img src={Logo} alt="Aysa Logo" />
        </Link>
      </Box>

      {/* Row 2: Copyright */}
      <Typography
        variant="body2"
        sx={{ mb: 3, color: "#F3F3F3", fontSize: "0.9rem" }}
        className="footer_copy_right"
      >
        © {new Date().getFullYear()} Aysa
      </Typography>

      {/* Row 3: Links */}
      <Box display="flex" justifyContent="center" gap={3} className="footer_menu">
        <MuiLink
          component={Link}
          to="/privacy-policy"
          sx={{
            color: "#F3F3F3",
            textDecoration: "none",
            "&:hover": { textDecoration: "underline" },
          }}
        >
          Privacy Policy
        </MuiLink>
        <MuiLink
          component={Link}
          to="/terms"
          sx={{
            color: "#F3F3F3",
            textDecoration: "none",
            "&:hover": { textDecoration: "underline" },
          }}
        >
          Terms of Service
        </MuiLink>
      </Box>
    </Box>
  );
};
